export function dateDiff(showTime) {
  const [dia, mes, ano] = showTime.split("-")
  const data = new Date(ano, mes, dia)

  return Math.floor((new Date() - data) / (1000 * 60 * 60 * 24 * 365))
}
